<template>
  <div class="floating-bottom-bar">
<!-- 모바일: 원형 플로팅 버튼 -->
    <div class="mobile-float-btns mobile-only">
      <a href="tel:1644-4220" class="m-float-btn m-call">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
        </svg>
        <span class="m-btn-label">전화상담</span>
      </a>
      <button class="m-float-btn m-register" @click="openRegisterModal">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <line x1="19" y1="8" x2="19" y2="14"/>
          <line x1="16" y1="11" x2="22" y2="11"/>
        </svg>
        <span class="m-btn-label">관심고객</span>
      </button>
    </div>

    <!-- 관심고객등록 모달 -->
    <transition name="modal">
      <div v-if="showRegisterModal" class="modal-overlay" @click.self="closeRegisterModal">
        <div class="register-modal">
          <button class="modal-close" @click="closeRegisterModal">
            <span></span>
            <span></span>
          </button>
          <h3 class="modal-title">CONSULTATION</h3>
          <p class="modal-desc">관심고객 상담신청</p>

          <form @submit.prevent="submitRegister" class="register-form">
            <div class="form-group">
              <label>이름</label>
              <input type="text" v-model="registerForm.name" placeholder="이름을 입력하세요" required />
            </div>
            <div class="form-group">
              <label>연락처</label>
              <div class="phone-inputs">
                <input type="tel" inputmode="numeric" ref="regPhone1" v-model="registerForm.phone1" placeholder="010" maxlength="3" required @input="onPhoneInput('phone1', 3, 'regPhone2')" />
                <span class="phone-dash">-</span>
                <input type="tel" inputmode="numeric" ref="regPhone2" v-model="registerForm.phone2" placeholder="0000" maxlength="4" required @input="onPhoneInput('phone2', 4, 'regPhone3')" />
                <span class="phone-dash">-</span>
                <input type="tel" inputmode="numeric" ref="regPhone3" v-model="registerForm.phone3" placeholder="0000" maxlength="4" required @input="onPhoneInput('phone3', 4, null)" />
              </div>
            </div>
            <div class="form-group checkbox">
              <label class="checkbox-label">
                <input type="checkbox" v-model="registerForm.agree" required />
                <span class="checkmark"></span>
                <span>개인정보 수집 및 이용에 동의합니다.</span>
              </label>
            </div>
            <button type="submit" class="submit-btn" :disabled="isSubmitting">
              {{ isSubmitting ? '등록 중...' : '상담 신청하기' }}
            </button>
          </form>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import { registerCustomer } from '@/firebase/customerService'

export default {
  name: 'FloatingBottomBar',
  data() {
    return {
      showRegisterModal: false,
      isSubmitting: false,
      registerForm: {
        name: '',
        phone1: '010',
        phone2: '',
        phone3: '',
        agree: false
      }
    }
  },
  mounted() {
    window.addEventListener('open-register-modal', this.openRegisterModal)
  },
  beforeUnmount() {
    window.removeEventListener('open-register-modal', this.openRegisterModal)
  },
  methods: {
    goToReservation() {
      this.$router.push('/reservation/register')
    },
    openRegisterModal() {
      this.showRegisterModal = true
      document.body.style.overflow = 'hidden'
    },
    closeRegisterModal() {
      this.showRegisterModal = false
      document.body.style.overflow = ''
    },
onPhoneInput(field, maxLen, nextRef) {
      this.registerForm[field] = this.registerForm[field].replace(/[^0-9]/g, '')
      if (this.registerForm[field].length >= maxLen && nextRef) {
        this.$refs[nextRef].focus()
      }
    },
    async submitRegister() {
      if (!this.registerForm.agree) {
        alert('개인정보 수집 및 이용에 동의해주세요.')
        return
      }

      this.isSubmitting = true

      try {
        await registerCustomer({
          name: this.registerForm.name,
          phone: `${this.registerForm.phone1}${this.registerForm.phone2}${this.registerForm.phone3}`
        })
        // 모비온 데이터매니저 - 상담신청 전환 이벤트
        if (window.callDM) window.callDM('conversion')
        // 네이버 전환 스크립트 - 신청완료(lead)
        if (window.wcs) {
          if (!window.wcs_add) window.wcs_add = {}
          window.wcs_add['wa'] = 's_248a9401d7df'
          var _conv = {}
          _conv.type = 'lead'
          window.wcs.trans(_conv)
        }
        // Google Ads 전환 - 리드 양식 제출
        if (window.gtag) {
          window.gtag('event', 'conversion', {
            'send_to': 'AW-17708301937/M9zdCPWT-robEPH8_PtB',
            'value': 1.0,
            'currency': 'KRW'
          })
        }
        alert(`${this.registerForm.name}님, 상담 신청이 완료되었습니다.\n빠른 시일 내에 연락드리겠습니다.`)
        this.registerForm = { name: '', phone1: '010', phone2: '', phone3: '', agree: false }
        this.closeRegisterModal()
      } catch (error) {
        console.error('등록 오류:', error)
        alert('등록 중 오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>

<style scoped>
/* ===== 우측 하단 플로팅 ===== */
.fab-group {
  position: fixed;
  bottom: 36px;
  right: 36px;
  z-index: 800;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.fab {
  width: 80px;
  height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0;
  border: none;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

/* 유리닦는 shine 효과 */
.fab-shine {
  position: absolute;
  top: 0;
  left: -100%;
  width: 60%;
  height: 100%;
  background: linear-gradient(
    120deg,
    transparent 0%,
    transparent 30%,
    rgba(255, 255, 255, 0.25) 50%,
    transparent 70%,
    transparent 100%
  );
  animation: fabShine 3s ease-in-out infinite;
  pointer-events: none;
}

@keyframes fabShine {
  0% { left: -100%; }
  50%, 100% { left: 150%; }
}

/* 금색 모서리 장식 */
.fab-border {
  position: absolute;
  width: 14px;
  height: 14px;
  pointer-events: none;
  transition: all 0.4s ease;
}

.fab-border-tl {
  top: 4px;
  left: 4px;
  border-top: 1px solid #c9a96e;
  border-left: 1px solid #c9a96e;
}

.fab-border-br {
  bottom: 4px;
  right: 4px;
  border-bottom: 1px solid #c9a96e;
  border-right: 1px solid #c9a96e;
}

.fab:hover .fab-border-tl {
  width: 20px;
  height: 20px;
  top: 3px;
  left: 3px;
}

.fab:hover .fab-border-br {
  width: 20px;
  height: 20px;
  bottom: 3px;
  right: 3px;
}

.fab-icon {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.fab-icon svg {
  width: 100%;
  height: 100%;
}

.fab:hover .fab-icon {
  transform: scale(1.1);
}

.fab-text {
  font-family: var(--font-paperlogy);
  font-size: 8px;
  font-weight: 600;
  letter-spacing: 2px;
  position: relative;
  z-index: 1;
  opacity: 0.8;
  transition: opacity 0.3s ease;
}

.fab:hover .fab-text {
  opacity: 1;
}

/* 영상 버튼 — 다크 + 금색 보더 */
.fab-video {
  background: linear-gradient(145deg, #1a1a1a 0%, #0d0d0d 100%);
  color: #c9a96e;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
}

.fab-video:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.4);
}

/* 상담 버튼 — 프라이머리 + 금색 보더 */
.fab-register {
  background: linear-gradient(145deg, var(--ecofore-primary) 0%, var(--ecofore-primary-dark) 100%);
  color: #fff;
  box-shadow: 0 4px 20px rgba(180, 106, 85, 0.25);
}

.fab-register .fab-border-tl,
.fab-register .fab-border-br {
  border-color: rgba(255, 255, 255, 0.35);
}

.fab-register:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 36px rgba(180, 106, 85, 0.4);
}

.fab-register:hover .fab-border-tl,
.fab-register:hover .fab-border-br {
  border-color: rgba(255, 255, 255, 0.5);
}

/* ===== 모달 공통 ===== */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9000;
  padding: 20px;
  backdrop-filter: blur(3px);
}

.modal-overlay.video-overlay {
  background: rgba(0, 0, 0, 0.9);
}

.modal-close {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;
}

.modal-close span {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 24px;
  height: 2px;
  background: #333;
  transition: background 0.3s ease;
}

.modal-close span:first-child {
  transform: translate(-50%, -50%) rotate(45deg);
}

.modal-close span:last-child {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.modal-close:hover span {
  background: var(--ecofore-primary);
}

.modal-close.white span {
  background: #fff;
}

.modal-close.white:hover span {
  background: rgba(255, 255, 255, 0.7);
}

/* ===== 관심고객등록 모달 (정사각형) ===== */
.register-modal {
  position: relative;
  width: 520px;
  height: 520px;
  background: #fff;
  border-radius: 0;
  padding: 56px 48px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/* 모서리 장식 */
.register-modal::before,
.register-modal::after {
  content: '';
  position: absolute;
  width: 40px;
  height: 40px;
  border-color: var(--ecofore-accent);
  border-style: solid;
}

.register-modal::before {
  top: 12px;
  left: 12px;
  border-width: 1px 0 0 1px;
}

.register-modal::after {
  bottom: 12px;
  right: 12px;
  border-width: 0 1px 1px 0;
}

.modal-title {
  font-family: var(--font-luxury);
  font-size: 14px;
  font-weight: 500;
  color: var(--ecofore-accent);
  text-align: center;
  letter-spacing: 6px;
  text-transform: uppercase;
  margin-bottom: 6px;
}

.modal-desc {
  font-family: var(--font-pretendard);
  font-size: 22px;
  font-weight: 600;
  color: #1a1a1a;
  text-align: center;
  margin-bottom: 36px;
}

.register-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-family: var(--font-pretendard);
  font-size: 12px;
  font-weight: 600;
  color: #999;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.form-group input[type="text"],
.form-group input[type="tel"] {
  padding: 12px 0;
  border: none;
  border-bottom: 1px solid #ddd;
  border-radius: 0;
  font-family: var(--font-pretendard);
  font-size: 15px;
  color: #1a1a1a;
  transition: border-color 0.3s ease;
  background: transparent;
}

.form-group input[type="text"]:focus,
.form-group input[type="tel"]:focus {
  outline: none;
  border-bottom-color: var(--ecofore-accent);
}

.phone-inputs {
  display: flex;
  align-items: center;
  gap: 6px;
}

.phone-inputs input {
  flex: 1;
  text-align: center;
  min-width: 0;
}

.phone-dash {
  color: #ccc;
  font-size: 14px;
  flex-shrink: 0;
}

.form-group.checkbox {
  margin-top: 4px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-size: 13px;
  color: #888;
}

.checkbox-label input[type="checkbox"] {
  display: none;
}

.checkmark {
  width: 18px;
  height: 18px;
  border: 1.5px solid #ccc;
  border-radius: 2px;
  position: relative;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.checkbox-label input[type="checkbox"]:checked + .checkmark {
  background: var(--ecofore-primary);
  border-color: var(--ecofore-accent);
}

.checkbox-label input[type="checkbox"]:checked + .checkmark::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 5px;
  width: 5px;
  height: 9px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.submit-btn {
  margin-top: 8px;
  padding: 14px;
  background: var(--ecofore-primary);
  border: none;
  border-radius: 0;
  font-family: var(--font-pretendard);
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 2px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.submit-btn:hover {
  background: var(--ecofore-primary-dark);
}

.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ===== 홍보영상 모달 ===== */
.video-modal {
  position: relative;
  width: 100%;
  max-width: 900px;
}

.video-wrapper {
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
}

.video-wrapper iframe {
  width: 100%;
  height: 100%;
}

/* ===== 모달 트랜지션 ===== */
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s ease;
}

.modal-enter-active .register-modal,
.modal-leave-active .register-modal,
.modal-enter-active .video-modal,
.modal-leave-active .video-modal {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .register-modal,
.modal-leave-to .register-modal,
.modal-enter-from .video-modal,
.modal-leave-to .video-modal {
  transform: scale(0.95);
  opacity: 0;
}

/* ===== 데스크톱/모바일 전환 ===== */
.desktop-only {
  display: flex;
}
.mobile-only {
  display: none;
}

/* ===== 모바일 플로팅 버튼 ===== */
.mobile-float-btns {
  position: fixed;
  bottom: 55px;
  right: 20px;
  flex-direction: column;
  gap: 12px;
  z-index: 800;
}

.m-float-btn {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 76px;
  height: 76px;
  border-radius: 50%;
  border: none;
  text-decoration: none;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  overflow: visible;
}

/* 회전하는 금색 그라데이션 테두리 */
.m-float-btn::after {
  content: '';
  position: absolute;
  top: -3px;
  left: -3px;
  right: -3px;
  bottom: -3px;
  border-radius: 50%;
  background: conic-gradient(
    from 0deg,
    #D4AF37,
    #FFF8DC,
    #D4AF37,
    #B8860B,
    #FFD700,
    #D4AF37
  );
  z-index: -1;
  animation: mRotateGold 3s linear infinite;
}

@keyframes mRotateGold {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.m-float-btn:active {
  transform: scale(0.95);
}

.m-float-btn svg {
  position: relative;
  z-index: 2;
}

.m-btn-label {
  font-family: var(--font-pretendard);
  font-size: 11px;
  font-weight: 600;
  margin-top: 4px;
  position: relative;
  z-index: 2;
}

/* 전화상담 버튼 */
.m-call {
  background: var(--ecofore-primary);
  color: #fff;
}

.m-call::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 56px;
  height: 56px;
  background: url('@/assets/logo/logo_symbol.png') no-repeat center;
  background-size: contain;
  opacity: 0.15;
  filter: brightness(0) invert(1);
  z-index: 1;
}

/* 관심고객등록 버튼 */
.m-register {
  background: #fff;
  color: var(--ecofore-accent);
}

.m-register::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 56px;
  height: 56px;
  background: url('@/assets/logo/logo_symbol.png') no-repeat center;
  background-size: contain;
  opacity: 0.1;
  z-index: 1;
}

/* ===== 모바일 (max-width: 768px) ===== */
@media (max-width: 768px) {
  .desktop-only {
    display: none !important;
  }
  .mobile-only {
    display: flex !important;
  }

  /* 모달 오버레이 */
  .modal-overlay {
    padding: 16px;
    align-items: center;
  }

  /* 관심고객등록 모달 */
  .register-modal {
    width: 100%;
    max-width: 400px;
    height: auto;
    padding: 36px 24px 32px;
  }

  .register-modal::before,
  .register-modal::after {
    width: 28px;
    height: 28px;
  }

  .modal-close {
    top: 12px;
    right: 12px;
    width: 44px;
    height: 44px;
  }

  .modal-close span {
    width: 20px;
  }

  .modal-title {
    font-size: 12px;
    letter-spacing: 4px;
    margin-bottom: 4px;
  }

  .modal-desc {
    font-size: 18px;
    margin-bottom: 24px;
  }

  .register-form {
    gap: 14px;
  }

  .form-group label {
    font-size: 11px;
  }

  .form-group input[type="text"],
  .form-group input[type="tel"] {
    padding: 14px 0;
    font-size: 16px; /* 16px prevents iOS zoom on focus */
    min-height: 44px;
  }

  .phone-inputs {
    gap: 4px;
  }

  .phone-inputs input {
    min-height: 44px;
  }

  .checkbox-label {
    font-size: 13px;
    min-height: 44px;
    gap: 8px;
  }

  .checkmark {
    width: 22px;
    height: 22px;
  }

  .checkbox-label input[type="checkbox"]:checked + .checkmark::after {
    top: 3px;
    left: 6px;
    width: 6px;
    height: 10px;
  }

  .submit-btn {
    padding: 16px;
    font-size: 15px;
    min-height: 48px;
  }

  /* 홍보영상 모달 */
  .video-modal {
    max-width: 100%;
  }

  .modal-overlay.video-overlay {
    padding: 12px;
    align-items: center;
    padding-top: 0;
  }

  .video-modal .modal-close {
    top: -44px;
    right: 0;
    width: 44px;
    height: 44px;
  }

  .video-wrapper {
    border-radius: 4px;
  }
}
</style>
